import ContributionsList from "../../components/admin/AllContributions";
import "./contribution.css";

const Contributions = () => {
  return (
    <div className="Mainorders">
      {/* <h1>Orders</h1> */}
      <ContributionsList />
      {/* <Table /> */}
    </div>
  );
};

export default Contributions;
